import { render, staticRenderFns } from "./BetSlipTerminal.vue?vue&type=template&id=5d4df748&scoped=true"
import script from "./BetSlipTerminal.vue?vue&type=script&lang=js"
export * from "./BetSlipTerminal.vue?vue&type=script&lang=js"
import style0 from "./BetSlipTerminal.vue?vue&type=style&index=0&id=5d4df748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4df748",
  null
  
)

export default component.exports